const IMG_API = "assets/device";
const list = [{
        id: [33, 34],
        brandId: 1,
        specImageShow: `${IMG_API}/account/OPPO@2x.png`,
        specContent: "Không thể xóa tài khoản OPPO bằng cách khôi phục cài đặt gốc. Để tránh ảnh hưởng đến giá thu hoặc phải làm phiền bạn khi kiểm tra chất lượng, xin vui lòng đăng xuất tài khoản hiện tại.", // OPPO账号是无法通过还原出厂设置来清除的。以防质检时需要询问您，或者影响回收价格。请先退出现有账号再回收。
    },
    {
        id: [33, 34],
        brandId: 4,
        specImageShow: `${IMG_API}/account/huawei@2x.png`,
        specContent: "Tài khoản Huawei không thể xóa sạch bằng cách dùng khôi phục cài đặt gốc. Để tránh khi kiểm tra chất lượng cần liên hệ bạn hỏi thông tin hoặc ảnh hưởng đến giá cả thu hồi, xin hãy đăng xuất khỏi tài khoản hiện tại rồi mới thu hồi.", // 华为账号是无法通过还原出厂设置来清除的。以防质检时需要询问您，或者影响回收价格。请先退出现有账号再回收。
    },
    {
        id: [33, 34],
        brandId: "",
        specImageShow: `${IMG_API}/account/other@2x.png`,
        specContent: "Chúng tôi nhận được điện thoại chưa mở khóa (màn hình và tài khoản bị khóa), không thể kiểm tra chất lượng, hơn nữa cần bạn chịu phí vận chuyển trả về", // 我们收到未解锁手机（屏幕锁和账号锁）无法质检，且需您承担退回运费。
    },
    {
        id: [16, 17],
        brandId: 2,
        specImageShow: `${IMG_API}/account/iphone@2x.png`,
        specContent: "Không thể xóa tài khoản iCloud bằng cách khôi phục cài đặt gốc. Để tránh ảnh hưởng đến giá thu hoặc phải làm phiền bạn khi kiểm tra chất lượng, xin vui lòng gỡ bỏ tài khoản iCloud.",
    },
    {
        id: [11],
        brandId: "",
        specImageShow: `${IMG_API}/fuselage/1@2x.png`,
        specContent: "Máy móc, bao bì, linh kiện đầy đủ; Máy chưa kích hoạt sử dụng; Ngoại quan máy, linh kiện không tì vết- khe sim, ốc vít ở thân máy, pin, bút cảm ứng không được thiếu; Bao bì, tem dán không bị hỏng, con dấu, tô vẽ, phụ kiện (đồ sạc, sách hướng dẫn, bảo hành,  bao đổi, bao trả, quyền truy cập mạng) không thiếu hay mài mòn", // 机器、包装、配件齐全，机器未激活使用，机器、配件无外观瑕疵——卡托、机身螺丝、电池、手写笔不能缺失；包装、标签无破损、印章、涂写，配件（充电器、说明书、三包、进网许可）无缺失磨损。
    },
    {
        id: [12],
        brandId: "",
        specImageShow: `${IMG_API}/fuselage/2@2x.png`,
        specContent: "Những chỗ như vỏ ngoài thân máy, camera, lỗ cắm tai nghe, nút ấn, LOGO...không có bất kỳ vết xước, va đập tróc sơn, không mất nút ấn, vỏ ngoài", // 机身外壳、摄像头、耳机孔、按键、LOGO等处，无任何痕迹、磕碰掉漆，按键、外壳无缺失。
    },
    {
        id: [13],
        brandId: "",
        specImageShow: `${IMG_API}/fuselage/3@2x.png`,
        specContent: "Những chỗ như vỏ ngoài thân máy, camera, lỗ cắm tai nghe, nút ấn, LOGO... khi chiếu sáng có thể thấy vết trầy hoặc một chút mài mòn, tróc sơn≥0.5mm", // 机身外壳、摄像头、耳机孔、按键、LOGO等处，光照下可见划痕或轻微磨损，0.5mm≤掉漆。
    },
    {
        // id: [14, 35, 45],
        id: [14, 35],
        brandId: "",
        specImageShow: `${IMG_API}/fuselage/4@2x.png`,
        specContent: "Những chỗ như vỏ ngoài thân máy, camera, lỗi cắm tai nghe, nút ấn, LOGO...bị va đập, tróc sơn.", // 机身外壳、摄像头、耳机孔、按键、LOGO等处，有磕碰、掉漆。
    },
    {
        id: [15],
        brandId: "",
        specImageShow: `${IMG_API}/fuselage/5@2x.png`,
        specContent: "Những chỗ như vỏ ngoài thân máy, camera, lỗ cắm tai nghe, nút ấn, LOGO...thiếu/ rạn nứt.", // 机身外壳、摄像头、耳机孔、按键、LOGO等处，缺失/裂缝。
    },
    {
        id: [18],
        brandId: "",
        specImageShow: `${IMG_API}/appearance/1@2x.png`,
        specContent: "Kính màn hình và đường viền không có bất kỳ vấn đề gì như vết xước, hư hại, tróc sơn, nổi bong bóng...", // 屏幕玻璃及边缘无划痕、破损、掉漆、气泡等任何问题。
    },
    {
        //id: [19, 46],
        id: [19],
        brandId: "",
        specImageShow: `${IMG_API}/appearance/2@2x.png`,
        specContent: "Gỡ bỏ miếng dán, dùng vải lau sạch. Dưới ánh sáng mạnh của đèn huỳnh quang hay ngoài trời...có thể nhìn thấy vết xước.", // 撕开贴膜，用布擦拭干净。日光灯、户外等强光照下可见划痕。
    },
    {
        id: [20, 36],
        brandId: "",
        specImageShow: `${IMG_API}/appearance/3@2x.png`,
        specContent: "1. Màn hình có vết xước ≥10mm, có cảm giác khi sờ bằng đầu ngón tay (không phải móng tay); 2. Viền màn hình bị va đập thiếu góc hoặc bong keo; 3. Khu vực hiển thị của màn hình có bong bóng.",
    },
    {
        id: [21],
        brandId: "",
        specImageShow: `${IMG_API}/appearance/4@2x.png`,
        specContent: "Màn hình hoặc đường viền có vết nứt, bị vỡ.", // 屏幕或边缘有裂纹、碎裂的情况。
    },
    {
        id: [22],
        brandId: "",
        specImageShow: `${IMG_API}/screen/1@2x.png`,
        specContent: "Trong giao diện màu thuần sắc, màu sắc, độ sáng thể hiện đồng đều, không có tình trạng như điểm sáng,  ngã vàng, ngã đỏ, đốm màu, nhấp nháy..", // 显示在纯色界面下，颜色、亮度均匀，无亮点、发黄、发红、色斑、闪烁等情况。
    },
    {
        id: [23],
        brandId: "",
        specImageShow: `${IMG_API}/screen/2@2x.png`,
        specContent: "Trên màn hình có màu khác thường, cảm biến ánh sáng hoặc các mảng có độ sáng khác thường; hoặc xuất hiện phân lớp, màu sắc đậm nhạt không đồng đều.", // 屏幕上存在颜色异常或亮度异常的光电或斑块；或者显示出现分层，颜色深浅不一。
    },
    {
        id: [24],
        brandId: "",
        specImageShow: `${IMG_API}/screen/3@2x.png`,
        specContent: "Màn hình điện thoại dùng lâu rồi thì ở những bề mặt khác cũng sẽ xuất hiện những chữ in mờ mờ, hoặc xuất hiện phân lớp.", // 手机屏幕，使用时间久了，即使在其他界面上也隐约有字印透出，或者显示出现分层。
    },
    {
        id: [25],
        brandId: "",
        specImageShow: `${IMG_API}/screen/4@2x.png`,
        specContent: "Các vấn đề như màn hình có hiện tượng chảy mực (khu vực không thể hiện màu đen), đường ngang dọc, nhấp nháy, lão hóa (giao diện màu thuần sắc lộ ra hình vẽ)..ảnh hưởng đến việc sử dụng bình thường.", // 屏幕显示出漏液（黑色不显示区域）、横竖线、闪烁、老化（纯色界面透出图案）等问题，影响正常使用。
    },
    {
        id: [26],
        brandId: "",
        specImageShow: `${IMG_API}/screen/5@2x.png`,
        specContent: "Màn hình bị đen không hiển thị; Hoặc có sáng màn hình nhưng không thể hiển thị các thông tin như chữ.", // 屏幕黑屏不显示；或者虽然亮屏，但没有任何地方可以显示出文字等信息。
    },
    {
        id: [29],
        brandId: "",
        specImageShow: `${IMG_API}/repair/1@2x.png`,
        specContent: "Bên trong thân máy không có bất kỳ vết tích sửa chữa, linh kiện đầy đủ không hàn nối, vết nạy, óc vít không bị thiếu.", // 机身内部无任何维修痕迹，零件齐全无焊接、巧撬痕，螺丝未缺失。
    },
    {
        id: [30],
        brandId: "",
        specImageShow: `${IMG_API}/repair/2@2x.png`,
        specContent: "màn hình có con dấu hoặc màn hình iphone 5, 5S, 5C, SE, 6, 6 plus có mã QR hoặc trình tự cáp màn hình không giống với máy chính hãng", // 在屏幕上有盖章，或者iphone 5、5S、5C、SE、6、6 plus屏幕露出二维码，或者排线顺序与原装屏不符。
    },
    {
        id: [32],
        brandId: "",
        specImageShow: `${IMG_API}/repair/3@2x.png`,
        specContent: "1. Đổi dung lượng, máy liền khối đổi vỏ ngoài; bo mạch chủ có con dấu, miếng đen tản nhiệt ở mặt sau điện thoại bị hư, nắp đã tháo rời, hàn bay chì; hệ thống không có số IMEI, hoặc không giống với số IMEI trên thân máy. 2. Nếu có trên 3 trường hợp sau thì tức là có dấu hiệu sửa qua: 1) Thiếu linh kiện, ốc vít bên trong; 2) Pin bị thay hoặc lỏng lẻo có dấu cạy; 3) Cổng kết nối hoặc loa bị sửa qua; 4) Có dán nhãn hoặc có con dấu ở chỗ khác ngoài bo mạch chủ; 3. Iphone phải tháo máy ra kiểm tra nhưng ốc vít chỗ cổng kết nối không mở được, hoặc khi tháo nắp và cáp màn hình iPhone 7,8 thì ốc vít không mở được.",
    },
    {
        id: [31],
        brandId: "",
        specImageShow: `${IMG_API}/repair/4@2x.png`,
        specContent: "Nếu một điện thoại mà cùng lúc có vết tích sửa chữa màn hình, sửa chữa bo mạch chủ/ sửa chữa nhiều nơi thì chọn \"màn hình và bo mạch chủ đều có sửa chữa", // 若手机同时有屏幕维修、主板维修/多处维修痕迹时，选择“屏幕和主板均有维修”。
    }, {
        id: [154],
        brandId: '',
        specImageShow: `${IMG_API}/others/1.png`,
        specContent: 'Thân máy bị nứt, gãy, cong vẹo, biến dạng rõ ràng.' // 机身有明显碎裂、折断、弯曲、变形。
    }, {
        id: [74],
        brandId: '',
        specImageShow: `${IMG_API}/others/3.png`,
        specContent: 'Màn hình có vết ố, chỗ đỡ màn hình bong keo, miếng che màn hình nổi bong bóng, vị trí ống nghe tróc sơn hoặc bị thiếu.' // 屏幕进灰、屏幕支架脱胶、屏幕盖板气泡听筒位置掉漆和缺失。
    }, {
        id: [75],
        brandId: '',
        specImageShow: `${IMG_API}/others/2.png`,
        specContent: 'Màn hình bị vỡ, nứt do rơi rớt hoặc va chạm, bao gồm nhưng không giới hạn các rủi ro trong quá trình tiếp tục sử dụng về sau như nứt vỡ nhiều, rơi nhiều...' // 屏幕因跌落或碰撞而造成的破碎、裂开，包含但不限于后续在继续使用过程中碎裂增大、掉落等风险。
    }
    /*, {
       id: [28],
       brandId: '',
       specContent: '因隐私问题，仅支持环保回收，价格较低。'
     }*/
    ,
];
let formatProperties = (properties, brandId) => {
    if (properties && properties.length > 0) {
        for (let i = 0, l1 = properties.length; i < l1; i++) {
            if (properties[i].optionList.length > 0) {
                for (let j = 0, l2 = properties[i].optionList.length; j < l2; j++) {
                    properties[i].optionList[j] = optionItem(
                        properties[i].optionList[j],
                        brandId,
                        properties[i].keyName
                    );
                }
            }
        }
    }
    return properties;
};
let optionItem = (item, brandId, keyName) => {
    for (let m = 0, l = list.length; m < l; m++) {
        if (
            list[m].id.indexOf(item.id) > -1 && keyName != 'itemList' &&
            (list[m].brandId == brandId || !list[m].brandId)
        ) {
            let specItem = Object.assign({}, list[m]);
            delete specItem.id;
            delete specItem.brandId;
            return Object.assign(item, specItem);
        }
    }
    return item;
};

export default formatProperties;
